import "./App.css";
import JewelryHome from "./JewelryHome";

function App() {
  return (
    <div className="App">
      <JewelryHome />
    </div>
  );
}

export default App;
